export function mergeRefs<T>(...refs: Array<React.Ref<T> | undefined>) {
    return (value: T) => {
        for (const ref of refs) {
            if (!ref) continue;
            if (typeof ref === "function") ref(value);
            else (ref as any).current = value;
        }
    };
}

export const randomEnumValue = <T extends Record<string, string | number>>(enumeration: T): T[keyof T] => {
  const values = Object.values(enumeration);
  const enumValues = values.filter(value => typeof value !== 'number') as T[keyof T][];
  const randomIndex = Math.floor(Math.random() * enumValues.length);
  return enumValues[randomIndex];
};